import { Checkbox, FormControlLabel, Grid, TextField, Typography } from "@mui/material";
import React from "react";

export default function PaySlipHeader({handleInputChange,formData}) {

  return (
    
        <Grid container spacing={2} style={{ marginBottom: "30px" }} alignItems="center" justifyContent="center">
          <Grid item xs={12} md={6} sm={6} sx={{ display: "flex", alignItems: "center" }}>
    
            {/* <FormControlLabel control={<Checkbox value={"Y"} />} name="default_status" label="Save as default" /> */}
    
          </Grid>
    
          <Grid item xs={12} md={8} sm={8}>
    
            <TextField
    
              label="Header 1"
    
              name="header1"
    
              fullWidth
    
              onChange={handleInputChange}
    
              multiline
    
              value={formData.header1}
    
              className="inputRounded"
    
              required
    
            />
    
          </Grid>
    
          <Grid item xs={12} md={8} sm={8}>
    
            <TextField
    
              label="Header 2"
    
              name="header2"
    
              fullWidth
    
              onChange={handleInputChange}
    
              multiline
    
              value={formData.header2}
    
              className="inputRounded"
    
              required
    
            />
    
          </Grid>
    
          <Grid item xs={12} md={8} sm={8}>
    
            <TextField
    
              label="Header 3"
    
              name="header3"
    
              fullWidth
    
              onChange={handleInputChange}
    
              multiline
    
              value={formData.header3}
    
              className="inputRounded"
    
              required
    
            />
    
          </Grid>
    
        </Grid>
    
      );
    
    }
    